import {O} from "web-vcore";

export class UsersState {
	@O accessor subpage: string;
	@O accessor selectedUserID: string|n;
}